import React from "react";
import Box from "@mui/material/Box";
import { HyroLoader } from "@hyro-components";
import ResponsiveIframe from "@hyro-components/ResponsiveIframe/ResponsiveIframe";
import { getErrorPageFromStatus } from "src/layout/ErrorPages/ErrorPages.helpers";
import { useSigmaEmbedUrl } from "src/queries/hooks/sigma";
import { SIGMA_LOADER_TEXT } from "./SigmaDashboard.consts";

const SigmaDashboard = ({ assistantId, dashboardKey }) => {
  const { data, isError, error } = useSigmaEmbedUrl(assistantId, dashboardKey);

  if (isError) {
    const ErrorPage = getErrorPageFromStatus(error?.response?.status);
    return <ErrorPage />;
  }

  return (
    <Box mt={3}>
      {data?.url
        ? <ResponsiveIframe src={data.url} />
        : <HyroLoader text={SIGMA_LOADER_TEXT} />}
    </Box>
  );
};

export default SigmaDashboard;
